exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-item[data-v-19437886]{margin:50px auto;max-width:800px;padding:10px;border:var(--c-footer-bg) 2px solid;border-radius:5px}.show-item__image[data-v-19437886]{max-height:300px;max-width:100%;margin-bottom:20px}.show-item__icon[data-v-19437886]{width:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19437886","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ShowItem.vue
// module id = 268
// module chunks = 0